<template>
  <div class="page_1" :class="list.length <= 4  ? 'page_2': ''">
      <!-- <div class="con" style="">
        <span style="" v-for="(item,index) in tabList" :key="item" class="tab" :class="{active: columnIndex == index}" @click="changeTab(index,item)">{{item}}</span>
      </div> -->
      <div class="con" :class="showBar ? 'show' : ''">
        <span v-for="(item,index) in tabList" :key="index" class="tab" :class="{active: columnIndex == index}" @click="changeTab(index,item)">{{item}}</span>
      </div>
      <div class="list">
        <div v-for="(item,index) in list" :key="index" class="item" @click="toBuy(item.productCode)">
          <div class="proImg_">
            <img :src="item.productImageUrl" alt="">
            <div class="company_">{{item.companyName}}</div>
          </div>
          <div class="right_">
            <p class="title">{{item.productName}}</p>
            <!-- <span v-for="(item2,index2) in item.riskLiabilityList" :key="index2" class="risk">
              {{item2.riskLiability}}
            </span> -->
            <div v-html="item.productSellPoint" class="risk source_">
            </div>
            <p class="bottom_">
              <span class="price">{{item.price}}</span><span class="unit_">元起</span>
            </p>
            </div>
        </div>
      </div>
      <!-- <div class="btn" @click="extension">
        <img src="../../../assets/image/nsale/share.png" alt="">
        <span class="txt">转发组合推广</span>
      </div> -->
      <div class="mask" v-show="showMask" @click="hideMask">
        <img src="../../../assets/image/nsale/guide.png" alt="">
      </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import storage from '@/utils/storage'
export default {
  data() {
    return {
      productSource:"家政人员专属保障↵对雇主的赔偿责任",
      list: [],
      tabList: ["全部"],
      typeIdList: [],
      columnIndex: 0,
      queryParam: {
        start: 1,
        length: 10,
        noPage: 1
      },
      query: {},
      productIds: [],
      data: [],
      height: '',
      showBar: false,
      showMask: false,
      userId: '',
      avatarUrl: ''
    }
  },
  created() {
    this.query = this.$route.query
    console.log(this.query);
    this.userId = this.query.webuserid
    this.queryProductItems()
    window.addEventListener('scroll',this.handleScroll,true)
    this.queryUser()
    this.fetchJsSdkSign()
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    queryUser() {
      api.queryUser({userId: this.userId}).then(res => res.data).then(data => {
        const { imageUrl } = data.content
        this.avatarUrl = imageUrl
      })
    },
    fetchJsSdkSign() {
      let url = location.href.split("#")[0];
      this.linkurl = url;
      let _this = this;
      api
        .getJsJdkSign2({
          url: url,
          userId: this.userId
        })
        .then(res => res.data)
        .then(async data => {
          const { appId, jssdkReqData } = data;
          console.log(appId, jssdkReqData);
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options)
          let opstion = {
            title: "产品推荐", // 分享标题
            link: window.location.href,
            imgUrl: _this.avatarUrl || 'http://nsale.yutai365.com/icon.jpg', // 分享图标
            desc: "我为您精选了系列保险产品，打开看看吧~",
            success: function() {
              console.log("success++");
            },
            error: function() {
              console.log("failed++");
            }
          };
          wxShare(opstion)
        });
    },
    toBuy(productCode) {
      // window.open(url)
      let data = {
        userId: this.query.webuserid,
        productCode: productCode
      }
      api.queryCombinationOneProductUrl(data).then(res => {
        window.location.href = res.data.data
      })
    },
    changeTab(index,tabName) {
      this.list = []
      this.data.forEach(item => {
        if(tabName == '全部') {
          this.list = this.data
        }
        else if (item.productClassName == tabName) {
          this.list.push(item)
        }
      })
      this.columnIndex = index
    },
    queryProductItems() {
      this.queryParam.webuserid =  this.query.webuserid
      api.queryProductItems(this.queryParam.webuserid,this.query.productIds).then(res => {
        this.data = res.data.data
        this.list = res.data.data
        this.list.forEach(item => {
          if (this.tabList.indexOf(item.productClassName) == -1 ) {
            this.tabList.push(item.productClassName)
          }
        })
      })
    },
    handleScroll(e) {
      var top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
      this.height=top
    },
    extension() {
      // const component = this.$refs.myPopup4
      // component.show()
      this.showMask = true
    },
    hideMask() {
      this.showMask = false
    }
  },
  watch: {
    height: {
      handler(newHeight,oldHeight) {
        if (newHeight > 40) {
          this.showBar = true
        } else {
          this.showBar = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page_1 {
  background-color: #F8F8F8;
  margin: 0 auto;
  overflow: hidden;
  // height: 100%;
  .con {
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    width: 100%;
    display:flex;
    overflow-x: auto;
    .tab {
      font-weight: 500;
      font-size:15px;
      height:100%;
      flex: 1;
      white-space: nowrap;
      margin: 0 6px;
    }
    // &.show {
    //   z-index: 999;
    //     background-color: #fff;
    //     position: fixed;
    //     top: 0;
    //     left: 0;
    //   }
    .active {
      font-weight: 700;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        display: block;
        width: 11px;
        height: 2px;
        border-radius: 4px;
        background-color: #FF7C6C;
        transform: translateX(-50%);
    }
    }
  }
  .list {
      margin: 15px 15px 0;
      .item {
        background-color: #fff;
        border-radius: 7px;
        display: flex;
        height: 135px;
        margin-bottom: 10px;
        position: relative;
        &:last-child {
          margin-bottom: 100px;
        }
        .proImg_ {
          width: 120px;
          height: 100%;
          position: relative;
          .company_{
            position: absolute;
            bottom:0;
            left: 0;
            background: rgba(245,245,245,1);
            width: 100%;
            height: 26px;
            border-radius: 0rem 0rem 0 7px;
            font-size: 0.29rem;
            font-weight: bold;
            color: rgba(102,102,102,1);
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          img {
            width: 120px;
            height: 135px;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
          }
        }
        .right_ {
          text-align: left;
          margin-left: 10px;
          .source_{
            white-space: pre-wrap;
          }
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            margin-top: 13px;
            margin-bottom: 5px;
          }
          .risk {
            display: flex;
            font-size: 12px;
            color: #999;
            line-height: 16px;
          }
          .bottom_ {
            position: absolute;
            bottom: 0;
            .price {
              font-size: 18px;
              color: #FF4A35;
            }
            .unit_ {
              font-size: 11px;
              color: #666;
            }
          }
        }
      }
  }
  .btn {
    // margin: 50px auto 0;
    width: 90%;
    height: 60px;
    // position: relative;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
      height: 100%;
    }
    .txt {
      position: absolute;
      font-size: 16px;
      color: #fff;
      top: 22px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    img {
      position: fixed;
      top: 25px;
      left: 78px;
    }
  }
}
.page_2 {
  height: 100vh;
}
</style>

